<div class="push-notification-manager">
  <div class="card">
    <div class="card-header">
      <h5 class="card-title mb-0">
        <i class="bi bi-bell"></i>
        Push Notifications
      </h5>
    </div>
    <div class="card-body">
      <!-- Status Information -->
      <div class="status-info mb-3">
        <div class="alert" [ngClass]="{
          'alert-success': permission === 'granted' && isSubscribed,
          'alert-warning': permission === 'default' || (permission === 'granted' && !isSubscribed),
          'alert-danger': permission === 'denied' || !isSupported
        }">
          <i class="bi" [ngClass]="{
            'bi-check-circle-fill': permission === 'granted' && isSubscribed,
            'bi-exclamation-triangle-fill': permission === 'default' || (permission === 'granted' && !isSubscribed),
            'bi-x-circle-fill': permission === 'denied' || !isSupported
          }"></i>
          {{ statusText }}
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons mb-3">
        <div class="row g-2">
          <div class="col-md-6">
            <button
              class="btn btn-primary w-100"
              (click)="requestPermission()"
              [disabled]="!isSupported || permission === 'granted'">
              <i class="bi bi-shield-check"></i>
              Request Permission
            </button>
          </div>

          <div class="col-md-6">
            <button
              class="btn btn-success w-100"
              (click)="subscribe()"
              [disabled]="!isSupported || permission !== 'granted' || isSubscribed">
              <i class="bi bi-bell-fill"></i>
              Subscribe
            </button>
          </div>

          <div class="col-md-6">
            <button
              class="btn btn-warning w-100"
              (click)="unsubscribe()"
              [disabled]="!isSupported || !isSubscribed">
              <i class="bi bi-bell-slash"></i>
              Unsubscribe
            </button>
          </div>

          <div class="col-md-6">
            <button
              class="btn btn-info w-100"
              (click)="testNotification()"
              [disabled]="permission !== 'granted'">
              <i class="bi bi-send"></i>
              Test Notification
            </button>
          </div>
        </div>
      </div>

      <!-- Initialize Button -->
      <div class="mb-3">
        <button
          class="btn btn-outline-primary w-100"
          (click)="initializePushNotifications()"
          [disabled]="!isSupported">
          <i class="bi bi-gear"></i>
          Initialize Push Notifications
        </button>
      </div>

      <!-- User Preferences -->
      <div class="preferences-section mb-3" *ngIf="isSupported">
        <h6>Notification Preferences:</h6>
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            id="autoSubscribeSwitch"
            [checked]="autoSubscribeEnabled"
            (change)="onAutoSubscribeChange($any($event.target).checked)">
          <label class="form-check-label" for="autoSubscribeSwitch">
            Auto-subscribe on login
            <small class="text-muted d-block">Automatically subscribe to notifications when you log in</small>
          </label>
        </div>
      </div>

      <!-- Debug Actions -->
      <div class="debug-actions mb-3" *ngIf="isSupported">
        <button
          class="btn btn-outline-info w-100"
          (click)="getDetailedStatus()">
          <i class="bi bi-info-circle"></i>
          Get Detailed Status
        </button>
      </div>

      <!-- Technical Information -->
      <div class="technical-info" *ngIf="isSupported">
        <h6>Technical Information:</h6>
        <div class="info-grid">
          <div class="info-item">
            <strong>Supported:</strong>
            <span class="badge" [ngClass]="isSupported ? 'bg-success' : 'bg-danger'">
              {{ isSupported ? 'Yes' : 'No' }}
            </span>
          </div>
          <div class="info-item">
            <strong>Permission:</strong>
            <span class="badge" [ngClass]="{
              'bg-success': permission === 'granted',
              'bg-warning': permission === 'default',
              'bg-danger': permission === 'denied'
            }">
              {{ permission }}
            </span>
          </div>
          <div class="info-item">
            <strong>Subscribed:</strong>
            <span class="badge" [ngClass]="isSubscribed ? 'bg-success' : 'bg-secondary'">
              {{ isSubscribed ? 'Yes' : 'No' }}
            </span>
          </div>
        </div>

        <!-- Subscription Details -->
        <div class="subscription-details mt-3" *ngIf="subscription">
          <h6>Subscription Details:</h6>
          <div class="subscription-info">
            <pre>{{ subscriptionInfo }}</pre>
          </div>
        </div>

        <!-- Subscription Status -->
        <div class="subscription-status mt-3" *ngIf="subscriptionStatus">
          <h6>Subscription Status:</h6>
          <div class="status-info-detail">
            <div class="status-item">
              <strong>Status:</strong> {{ getCurrentSubscriptionStatus() }}
            </div>
            <div class="status-item" *ngIf="subscriptionStatus.userId">
              <strong>User ID:</strong> {{ subscriptionStatus.userId }}
            </div>
            <div class="status-item" *ngIf="subscriptionStatus.endpoint">
              <strong>Endpoint:</strong>
              <span class="endpoint-text">{{ subscriptionStatus.endpoint }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
